import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { NumberComparisonFilterField } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { getGridLabelKey } from "@ryde/shared";

import { IFilterByIdsReportProps } from "./filters-by-ids.report.models";
import { useTableFiltersActionsReports } from "./use-table-filters-actions-reports";

/**
 * Reports wiring for the shared number-comparison filter field: reports address a filter by its template
 * key and label it from the report's own translation namespace, where the grid uses a custom field id.
 * The stored "op:value" string is decoded into a criteria.where operator descriptor at request time
 * (buildReportWhereDescriptor in use-report-actions).
 */
export const FilterNumberComparisonReport = ({
  templateKey,
  initialCheckedValues,
}: IFilterByIdsReportProps): ReactElement => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { setValuesToFilter, handleRemoveFilter } =
    useTableFiltersActionsReports();

  const onApply = (encodedValue: string | undefined): void => {
    setValuesToFilter(templateKey, encodedValue ? [encodedValue] : []);
  };

  const onRemove = (): void => {
    handleRemoveFilter(templateKey);
  };

  return (
    <NumberComparisonFilterField
      fieldId={`report-filter-number-comparison-${templateKey}`}
      label={t(getGridLabelKey(entity, templateKey))}
      value={initialCheckedValues}
      onApply={onApply}
      onRemove={onRemove}
    />
  );
};
